export default __webpack_public_path__ + "static/media/hospedaje2024.6de2af8f.pdf";